import { LinkStatus } from './types'

export const status = {
  LIVE: <LinkStatus>{
    text: 'LIVE',
    color: 'failure',
  },
  SOON: <LinkStatus>{
    text: 'SOON',
    color: 'warning',
  },
  NEW: <LinkStatus>{
    text: 'NEW',
    color: 'success',
  },
}

export const MENU_HEIGHT = 50
export const MENU_ENTRY_HEIGHT = 48
export const ACCORDION_SUB_MENU_ENTRY_HEIGHT = 58
export const SIDEBAR_WIDTH_FULL = 240
export const SIDEBAR_WIDTH_REDUCED = 56
export const MOBILE_MENU_HEIGHT = 50
